import CircleChart from '@modules/AudienceManager/Components/Charts/CircleChart';
import BootstrapBox from "@core/Components/Util/BootstrapBox";
import Estimate from './Estimate.vue';
import Answers from './Answers.vue';


import resourceMixin from "@core/Util/Mixins/resources";

import loader from "@core/Util/loader";
import {
    bootstrapDangerGrowl as errorGrowl,
    bootstrapSuccessGrowl as successGrowl
} from "@core/Util/growler";
import {RouteNames} from "@modules/AudienceManager/constants";

import {createNamespacedHelpers} from "vuex";
const {mapState, mapActions, mapGetters} = createNamespacedHelpers('audienceManager/builder');

export default {
    name: "OverviewTab",
    components: {
        CircleChart,
        Estimate,
        Answers,
        BootstrapBox
    },
    mixins: [resourceMixin],
    methods: {
        ...mapActions({
            async saveAudience(dispatch){
                await this.handleSaveAction(dispatch, 'saveAudience');
            },
            async publishAudience(dispatch){ 
                await this.handleSaveAction(dispatch, 'publishAudience');
            }
        }),

        /**
         * Handles the given save action and redirects back to index once finished
         * @param {Function} dispatch Vuex dispatch handler
         * @param {String} actionName Vuex action name
         * @return {Promise<void>}
         */
        async handleSaveAction(dispatch, actionName) {
            try {
                loader.show();
                
                await dispatch(actionName);

                successGrowl(this.resource('AudienceManager_Builder_SaveSuccess_Message'));
                
                await this.$router.push({ name: RouteNames.INDEX });
            } catch (e) {
                errorGrowl(e); 
            } finally {
                loader.hide();
            }
        }
    },
    computed: {
        ...mapState(['audienceId']),
        ...mapGetters(['canEditAudience'])
    }
};
